import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { removeCartVoucherItem } from '../../../actions/action_cart_voucher_items';
import formatUSD from '../../../utils/formatUSD';

const VoucherSection = styled.div`
  border-top: 1px solid #eee;
  margin-top: 16px;
  padding-top: 16px;
`;

const SectionLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #666;
  margin-bottom: 12px;
`;

const VoucherItem = styled.div`
  display: block;
  padding: 12px 0;
  border-bottom: ${(props) => (props.isLastItem ? 'none' : '1px solid #eee')};
`;

const VoucherName = styled.div`
  font-weight: 900;
`;

const VoucherUnitPrice = styled.div`
  font-size: 13px;
  color: #666;
  font-weight: normal;
`;

const TotalToSpend = styled.span`
  display: inline-block;
  font-size: 13px;
  color: #166534;
  font-weight: 600;
  background-color: #ecfdf5;
  padding: 2px 6px;
  border-radius: 4px;
  margin-top: 4px;
`;

const VoucherQuantity = styled.div`
  font-size: 14px;
  color: #666;
`;

const VoucherTotalPrice = styled.div`
  font-weight: 900;
`;

const RemoveLink = styled.a`
  color: #479de6;
  display: block;
  padding-top: 4px;
  cursor: pointer;
  font-size: 13px;
  &:hover {
    color: #479de6;
  }
`;

const StudentVoucherItems = ({ items }) => {
  const dispatch = useDispatch();
  const cartUuid = useSelector((state) => state.v3Order?.uuid);

  if (!items || items.length === 0) {
    return null;
  }

  const handleRemove = (itemId) => {
    if (cartUuid) {
      dispatch(removeCartVoucherItem(cartUuid, itemId));
    }
  };

  return (
    <VoucherSection>
      <SectionLabel>Vouchers</SectionLabel>
      {items.map((item, index) => {
        const voucherProduct = item.voucher_product || {};
        const name = voucherProduct.name || item.name || 'Voucher';
        const unitPriceCents =
          voucherProduct.purchase_price_cents ||
          item.unit_price_cents ||
          (item.quantity ? item.subtotal_cents / item.quantity : 0);

        return (
          <VoucherItem
            key={`student-voucher-${item.id}`}
            isLastItem={index === items.length - 1}
            className="row"
          >
            <div className="col-xs-9">
              <VoucherName>{name}</VoucherName>
              <VoucherUnitPrice>{formatUSD(unitPriceCents)}</VoucherUnitPrice>
              {voucherProduct.total_value_cents && (
                <TotalToSpend>
                  Total to Spend: {formatUSD(voucherProduct.total_value_cents)}
                </TotalToSpend>
              )}
              <VoucherQuantity>Qty: {item.quantity}</VoucherQuantity>
            </div>
            <div className="col-xs-3 text-right">
              <VoucherTotalPrice>
                {formatUSD(item.subtotal_cents)}
              </VoucherTotalPrice>
              <RemoveLink onClick={() => handleRemove(item.id)}>
                Remove
              </RemoveLink>
            </div>
          </VoucherItem>
        );
      })}
    </VoucherSection>
  );
};

export default StudentVoucherItems;
